import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';

import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

export default class AdvertisePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div>
                <div className="advertise_boxs" id={isMobile?"a_welcome_mobile":"a_welcome"}>
                    <div className={"block-001"}>
						<Link to="/business"><img className={"img_logo"} src="/static/img/appimg/h_logo.png"/></Link>
                        {isMobile?
                            <MenuComponent is_hide={4}/>
                            :
                            <Link className="btn_login" to="/signin">Sign in</Link>
                        }
                    </div>
                    <div className={"block-002"}>
                        <div className={"content"}>
                            <p>&nbsp;</p>
                            <h2>Choose your audience</h2>
                            <p>Connect with students who love your business.</p>
                            <Link to="/employers/signup">Claim Your Free Page</Link>
                        </div>
                    </div>
                    <div className={"block-003"}>
                        <div className={"content1"}>
                            <h3 className={'t-24 t-bold'}>College students are here</h3>
                            <p className={'t-14'}>College students spend in excess of $60 billion dollars each year. With our powerful audience selection tools, you can target the students who are right for your business. Using what you know about your customers—like demographics, interests and behaviors—you can connect with people similar to them.</p>
                        </div>
                        <div className={"content2"}>
                            <div className={"item-001"}>
                                <img className="icon_cc" src="static/img/appimg/ads_icon1.png"/>
                                <h4>Build Brand Loyalty</h4>
                                <p className={'t-14'}>An immersive and interactive experiences creates deeper bonds and fosters longer term relationships.</p>
                            </div>
                            <div className={"item-002"}>
                                <img className="icon_cc" src="static/img/appimg/ads_icon2.png"/>
                                <h4>Be Unexpected</h4>
                                <p className={'t-14'}>Reach new audiences where they live. On their commute to school, at work, or in their neighborhood, the pop-up aspect of the experience will intrigue and excite.</p>
                            </div>
                            <div className={"item-003"}>
                                <img className="icon_cc" src="static/img/appimg/ads_icon3.png"/>
                                <h4>Personalized Experiences</h4>
                                <p className={'t-14'}>Allow visitors to connect to your posts making for memorable brand touches. </p>
                            </div>
                        </div>
                        <div className={"content3"}>
                            <h3 className={'t-24 t-bold'}>CORE AUDIENCES</h3>
                            <h3 className={"t-18 t-bold"}>Choose the students you want to reach</h3>
                            <p className={'t-14'}>Whether you’re a burger shop that wants more local customers or an online electronics retailer looking for students interested in your products, our Audiences targeting options-the targeting features allows you to reach people based on their demographics, location, interests and behaviors.</p>
                        </div>
                        <div className={"content4"}>
                            <div className={"item-001"}>
                                <img className="icon_cc" src="static/img/appimg/ads_img1.png"/>
                                <div className={"right"}>
                                    <b>Demographics</b>
                                    <p>Find students based on traits like age, gender, education, job titles, majors and more.</p>
                                    <p>&nbsp;</p>
                                    <b>Location</b>
                                    <p>Reach students in select schools or areas where you want to do business.</p>
                                    <p>&nbsp;</p>
                                    <b>Interests</b>
                                    <p>Find students based on what they’re into, like hobbies, favorite entertainment and more.</p>
                                </div>
                            </div>
                            <div className={"item-002"}>
                                {isMobile?"":<img className="icon_cc" src="static/img/appimg/ads_img2.png"/>}
                                <div className={"right"}>
                                    <h3 className={'t-24 t-bold'}>AUDIENCE INSIGHTS</h3>
                                    <h3 className={'t-18'}>Learn more about your audience</h3>
                                    <p>Audience insights help you learn more about your target audiences. You'll gather aggregate attributes about your customers, such as interests and behaviours – and you can use these to find new audiences who may be interested in your business.</p>
                                </div>
                                {isMobile?<img className="icon_cc" src="static/img/appimg/ads_img2.png"/>:""}
                            </div>
                        </div>
                        <div className={"content5"}>
                            <p>Start connecting with the people who will love your business.</p>
                            <div className={"item-002"}>
                                <img className="icon_cc" src="/static/img/appimg/ads_img3.png"/>
                                <div className={"right"}>
                                    <ul>
                                        <li>
                                            <h2>Company Pages</h2>
                                            <p>Ensure students learn more about your business or  brand, products and services, and job opportunities, with a free company profile.</p>
                                            <div className={"btns"}><Link to="/employers/signup">Get Started</Link><span><Link className={"more"} to="/companypages/contact-us">Learn more ></Link></span></div>
                                        </li>
                                        <li>
                                            <h2>Boost My Brand</h2>
                                            <p>Improve your brand visibility - helping you stand out from your competitors.</p>
                                            <div className={"btns"}><Link to="/employers/signup">Get Started</Link><span><Link className={"more"} to="/promote/contact-us">Learn more ></Link></span></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p>&nbsp;</p>
                        </div>
                    </div>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/advertise.js
 **/